import { FunctionComponent, Dispatch, SetStateAction } from "react";
import Logo from "../../assets/logo.png";
import "./Navbar.scss";

interface INavbarProps {
  setDropdown: Dispatch<SetStateAction<boolean>>;
}

export const Navbar: FunctionComponent<INavbarProps> = ({ setDropdown }) => {
  return (
    <div className="Navbar">
      <div className="Navbar_mobile">
        <img
          src={Logo}
          alt="Prosoft Engineering Logo"
          className="Navbar_logo"
        />
        <i className="fa fa-bars" onClick={() => setDropdown(true)}></i>
      </div>
      <div className="Navbar_web">
        <div className="Navbar_inner">
          <div className="Navbar_inner_top">
            <img
              src={Logo}
              alt="Prosoft Engineering Logo"
              className="Navbar_logo"
            />
            <div className="employee-links">
              <a
                className="employee-link-left"
                href="https://portal.prosoft-eng.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Employee Login
              </a>
              <a
                className="employee-link-right"
                href="https://mail.prosoft-eng.com/owa"
                target="_blank"
                rel="noopener noreferrer"
              >
                Employee Webmail
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
